// extracted by mini-css-extract-plugin
module.exports = {"backTop":"_12886"};